import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { useStore } from "../../redux/Store";
import { useCallback } from "react";
import action from '../Action';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-hot-toast';
import { MonthsEnum } from "../../types/MonthsEnum";
import MenuItem from '@mui/material/MenuItem';
import '../../types/variables.css';

const defaultValues = {
  emp_no: "",
  first_name: "",
  last_name: "",
  rt_month: "",
  include_terminated: false,
  include_on_leave: false,
  showResults: false
};
const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow:'scroll',
    height:'auto'
    }, 
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    },
  elementContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    }, 
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    },
  label: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    width: '125px',
    paddingTop: '10px',
    fontSize: '12pt'
    },
  labelCheckBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    overflow: 'none',
    width: 'auto',
    paddingTop: '10px',
    paddingRight: '10px',
    fontSize: '10pt'
    },
  Headers: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    fontSize: '11pt',
    fontStyle: 'italic'
    },
  field: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflow: 'none',
    paddingRight: '20px'
    },
  buttonRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    overflow: 'none',
    margin: '5px',
    width: '80px'
    },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    overflow: 'none',
    },

  })
);

const UserSearchHome = () => {
  const classes = useStyles();
  const store = useStore();
  const [formValues, setFormValues] = useState(defaultValues);

  const refresh = () => {
    setFormValues(defaultValues);
    toast.success('User Search fields cleared!', {
      id: 'refreshT',
      style: {
        border: '1px solid #e5e3e3',
        padding: '16px',
        color: '#1A2C80',
      }
    })
  };

  const errorToast = () => {
    toast.error('Please enter a valid Employee No, \nFirst Name, and/or Last Name to search.', {
    duration: 5000,
    id: 'errorT',
    style: {
      border: '1px solid #D5152E',
      padding: '16px',
      color: '#1A2C80'
      }
    });
  };
  const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z]+$/;

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    if (value !== "" && !ALPHA_NUMERIC_DASH_REGEX.test(value)) {
      return;
    }
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleNumChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    let input = e.target.value ;
      if( !input || ( input[input.length-1].match('[0-9]') && input[0].match('[100-999999]')) )
        setFormValues({
          ...formValues,
          [name]: value
        });
  };

  const handleTerminatedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({
      ...formValues,
      include_terminated: event.target.checked,
    })
  };

  const handleOnLeaveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({
      ...formValues,
      include_on_leave: event.target.checked,
    })
  };

  const updateSearchTerms = useCallback(() => {
    const { dispatch } = store;
    const searchTerms = {...formValues};
      searchTerms.showResults = true;
      // @ts-ignore
       dispatch(action("SEARCH_TERMS_UPDATED", searchTerms));
  }, [store, formValues]);

  const submitValidation =               
    (
      (
        (
          (formValues.first_name.length === 0 || ((formValues.first_name.length > 2) && (formValues.first_name.length <= 30)))
          && (formValues.last_name.length === 0 || ((formValues.last_name.length > 3) && (formValues.last_name.length <= 30)))
          && (formValues.emp_no.length === 0 || ((formValues.emp_no.length > 2) && (formValues.emp_no.length < 7)))
        )
        &&
        (
          formValues.first_name || formValues.last_name || formValues.emp_no
        )
      )
      ? true : false
    )
  
  return (
    <div className={classes.paper}>
      <form onSubmit={updateSearchTerms}>
        <div className={classes.elementContainer}>
          <div className={classes.Headers}>
            <h2>Enter Search Criteria</h2>
          </div>

          <div className={classes.innerContainer}>
          <div className={classes.elementContainer}>

          <div className={classes.innerContainer}>
            <div className={classes.innerContainer}>
              <div className={classes.label}>
                Employee No
              </div>
              <div className={classes.field}>
                <TextField 
                  error= {(((formValues.emp_no.length <= 2) || (formValues.emp_no.length >= 7)) && (formValues.emp_no.length !== 0)) ? true : false}
                  id="employee-no-input" 
                  name="emp_no"
                  onChange={handleNumChange}
                  type="text"
                  variant='outlined'
                  value={formValues.emp_no}
                  helperText={(((formValues.emp_no.length <= 2) || (formValues.emp_no.length >= 7)) && (formValues.emp_no.length !== 0)) ? "Enter a 3-6 digit Employee No": ""}
                  />
              </div>
            </div>
          </div>
          <br />
              <div className={classes.innerContainer}>
                <div className={classes.innerContainer}>
                  <div className={classes.label}>
                    First Name
                  </div>
                  <div className={classes.field}>
                    <TextField
                      error = {(((formValues.first_name.length <= 1) || (formValues.first_name.length >= 30)) && (formValues.first_name.length)) ? true : false}
                      id="first-name-input"
                      name="first_name"
                      type="text"
                      variant='outlined'
                      value={formValues.first_name}
                      onChange={handleInputChange}
                      helperText={(((formValues.first_name.length <= 1) || (formValues.first_name.length >= 30)) && (formValues.first_name.length)) ? "Enter a valid First Name": ""}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className={classes.innerContainer}>
                <div className={classes.innerContainer}>
                  <div className={classes.label}>
                    Last Name
                  </div>
                  <div className={classes.field}>
                    <TextField
                      error = {(((formValues.last_name.length <= 2) || (formValues.last_name.length >= 30)) && (formValues.last_name.length)) ? true : false}
                      id="last-name-input"
                      name="last_name"
                      type="text"
                      variant='outlined'
                      value={formValues.last_name}
                      onChange={handleInputChange}
                      helperText={(((formValues.last_name.length <= 2) || (formValues.last_name.length >= 30)) && (formValues.last_name.length)) ? "Enter a valid Last Name": ""}
                    />
                  </div> 
                </div>
              </div>
              <br />
            <div className={classes.innerContainer}>
              <div className={classes.innerContainer}>
                <div className={classes.label}>
                  RT Month
                </div>
                <div className={classes.field}>
                <TextField 
                  id="RT-month-input"
                  variant="outlined"
                  name="rt_month"
                  type="text"
                  select
                  inputProps={{ select: "true" }}
                  value={formValues.rt_month}
                  onChange={handleInputChange}
                  style={{width: 100}}
                >
                  {MonthsEnum.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                  
                </TextField>
                </div>
              </div>
            </div>
            </div>
            <div className={classes.elementContainer}>
              <div className={classes.field}>
                <Checkbox
                    id="include-terminated-state"
                    name="includeTerminated"
                    value={formValues.include_terminated}
                    onChange={handleTerminatedChange}
                    style={{ color: '#304CB2'}}
                  /> 
              <div className={classes.labelCheckBox}>
                Include Terminated
              </div>
              </div>
              <div className={classes.field}>
              <Checkbox
                id="include-on-leave-state"
                name="includeOnLeave"
                value={formValues.include_on_leave}
                onChange={handleOnLeaveChange}
                style={{ color: '#304CB2' }}
              />               
              <div className={classes.labelCheckBox}>
                Include On Leave
              </div>
              </div>
              </div>

              </div>

          <div className={classes.buttonContainer}>
            { 
              submitValidation? 
              (<Button variant="contained" type="submit" style={{color: 'fff', backgroundColor: '#304CB2'}} className={classes.buttonRight} title='Submit current search input(s) and load results'>Search </Button>) 
              : 
              (<Button variant="outlined" onClick={errorToast} style={{ color: '#e5e3e3', backgroundColor: 'fff'}} className={classes.buttonRight}>Search </Button>)
            }
            <Button variant="contained" onClick={refresh} className={classes.buttonRight} title='Reset current search input values'>
              Clear
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserSearchHome;
